package com.trevorwiebe.timesheet.signin.data

import kotlinx.serialization.Serializable

@Serializable
data class PasswordResetRequest(
    val email: String,
)
